export default "__VITE_ASSET__DsqKiqPe__"